var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganisationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.7463H22V18.7463H0V16.7463H2V1.74634C2 1.48112 2.10536 1.22677 2.29289 1.03923C2.48043 0.851695 2.73478 0.746338 3 0.746338H13C13.2652 0.746338 13.5196 0.851695 13.7071 1.03923C13.8946 1.22677 14 1.48112 14 1.74634V16.7463H16V6.74634H19C19.2652 6.74634 19.5196 6.8517 19.7071 7.03923C19.8946 7.22677 20 7.48112 20 7.74634V16.7463ZM6 8.74634V10.7463H10V8.74634H6ZM6 4.74634V6.74634H10V4.74634H6Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationIcon);
export default __webpack_public_path__ + "static/media/Organisation-icon.5b1a825db66e0462aee4ce958471e6de.svg";
export { ForwardRef as ReactComponent };